module.exports = __webpack_public_path__ + "img/arrow-up.9f7464e3.svg";